require("-!/home/lyj/goeasy/GoeasySelfCraftsChina/node_modules/.npminstall/extract-text-webpack-plugin/0.9.1/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!less-loader!/home/lyj/goeasy/GoeasySelfCraftsChina/node_modules/.npminstall/font-awesome-webpack/0.0.4/font-awesome-webpack/font-awesome-styles.loader.js!/home/lyj/goeasy/GoeasySelfCraftsChina/src/theme/font-awesome.config.prod.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/font-awesome-webpack/0.0.4/font-awesome-webpack/index.loader.js!./src/theme/font-awesome.config.prod.js
 ** module id = 1119
 ** module chunks = 0
 **/